<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PresetList',
  props: {
    presets: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    env: {
      type: String,
      default: () => 'prod',
      validator: value => {
        return ['prod', 'dev', 'staging'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      scrollBarEnd: false,
      scrolled: false,
      edit: false,
      deletedPresetIds: [],
    };
  },
  computed: {
    ...mapGetters({
      presetData: 'FormFinder/getPresetData',
      isLoggedIn: 'FormFinder/getLogInStatus',
      isLoading: 'FormFinder/getLoadingStatus',
    }),
  },
  methods: {
    changePreset(preset) {
      if (!this.edit) {
        if (preset.value) {
          this.$emit('input', preset.value);
        } else {
          this.$emit('input', preset.name);
        }
      }
    },
    handleRemovePreset(presetId) {
      this.deletedPresetIds.push(presetId);
    },
    async handleEditPreset() {
      if (!this.isLoading) {
        this.edit = !this.edit;
        if (!this.edit) {
          const { env, deletedPresetIds } = this;
          if (deletedPresetIds.length > 0) {
            this.$store.commit('SET_LOADING_STATUS', { isLoading: true });
            const success = await this.$store.dispatch('FormFinder/deletePresetData', { env, deletedPresetIds });
            if (success) {
              await this.$store.dispatch('FormFinder/fetchPresetData', { env });
              this.deletedPresetIds = [];
            }
          }
        }
      }
    },
    handleScroll() {
      const scrollBar = document.getElementsByClassName('preset-list')[0];
      this.scrolled = scrollBar.scrollLeft > 0;
      this.scrollBarEnd = scrollBar.scrollLeft === scrollBar.scrollWidth - scrollBar.clientWidth;
    },
  },
};
</script>

<template>
  <div class="preset-list__container">
    <h2>
      Presets
      <button
        v-if="presetData.length > 0 && isLoggedIn" 
        :class="{'preset-list__edit--saving': isLoading }"
        class="preset-list__edit"
        @click.prevent="handleEditPreset"
      >{{ edit ? 'Save' : 'Edit' }}</button>
    </h2>

    <div :class="{ 'scrolled': scrolled, 'scroll-end': scrollBarEnd }" class="preset-list-wrapper">
      <div class="preset-list" @scroll="handleScroll()">
        <template v-for="(preset, index) in presets">
          <div
            :key="`preset-item-${index}`"
            :class="{'active': value === preset.value }"
            class="preset-list-item"
            @click="changePreset(preset)"
          >{{ preset.label }}</div>
        </template>

        <template v-for="(preset, index) in presetData">
          <div
            :key="`preset-custom-${index}`"
            :class="[{'active': value === preset.name },{ 'disabled': deletedPresetIds.includes(preset.id) }]"
            class="preset-list-item"
            @click="changePreset(preset)"
          >{{ preset.name }}<a
            v-if="edit"
            class="preset-custom--remove"
            href="#"
            @click.prevent="handleRemovePreset(preset.id)"
          >+</a>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
